module.exports = __webpack_public_path__ + "static/img/login-logo1-en.cc161333.png";